import { LengthUnit, WeightUnit } from "@deliverr/commons-objects";

export const DEFAULT_WEIGHT_UNIT: WeightUnit = "lb";
export const DEFAULT_LENGTH_UNIT: LengthUnit = "in";
